import './form-shift-type.scss';
import { useFormContext } from "react-hook-form";
import { ShiftTypeFormSchema } from "@core/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";

type InputFormSchema = ShiftTypeFormSchema;
export function ShiftType() {
  const { control } = useFormContext<ShiftTypeFormSchema>();
  return (
    <div id="ShiftType" className="shift-type">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
    </div>
  );
}

export default ShiftType;